import { Extension } from '@tiptap/core'
import { PluginKey } from '@tiptap/pm/state'
import Suggestion from '@tiptap/suggestion'

import getSuggestionItems, { SuggestionItemsOptions } from './getSuggestionItems'
import renderItems from './renderItems'

const BLOCKS_WITHOUT_MENTIONS = ['bulletList', 'orderedList', 'blockquote']

const Mentions = Extension.create<SuggestionItemsOptions>({
  name: 'mentions',

  addOptions() {
    return {
      extraItems: [],
    }
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        char: '@',
        startOfLine: false,
        pluginKey: new PluginKey('mentions'),
        editor: this.editor,
        items: ({ editor, query }) => {
          return getSuggestionItems(query, editor, this.options)
        },
        render: renderItems,
        command: ({ editor, range, props }) => {
          props.command({ editor, range, props })
        },
        allow: ({ editor }) => {
          return !BLOCKS_WITHOUT_MENTIONS.some((block) => editor.isActive(block))
        },
      }),
    ]
  },
})

export default Mentions
